import React from "react";
import { FaDna } from "react-icons/fa";

const LoadingSpinner = ({ 
  size = "0.8em", 
  color = "currentColor", 
  className = "", 
  style = {} 
}) => {
  return (
    <FaDna 
      className={`spin ${className}`}
      style={{ 
        fontSize: size,
        color: color,
        ...style
      }}
    />
  );
};

export default LoadingSpinner;